export enum MessageType {
    Email = 0,
    Fax = 1,
    Mailer = 2
}

export const MessageTypeMetadata = {
    '0': {
        display: 'Email',
        value: 0
    },
    '1': {
        display: 'Fax',
        value: 1
    },
    '2': {
        display: 'Mailer',
        value: 2
    }
};
